import React, { useEffect, useState } from 'react';
import './ProductsModal.scss';
import { Modal, Checkbox, Button } from 'antd'

export default function ProductsModal({ open, closeModal, allProducts, selectedProducts, productsCrud }) {
    const [productList, setProductList] = useState([]);
    const handleSelectedProducts = (e, index) => {
        let result = [...productList]
        result[index] = {
            ...result[index],
            checked: e.target.checked
        }
        setProductList(result)
    }

    useEffect(() => {
        let selectedProductIds = selectedProducts.map(product => product.id)
        if (selectedProducts?.length > 0) {
            let temp = allProducts?.map((item) => {
                if (selectedProductIds.includes(item.id)) {
                    return { ...item, checked: true };
                } else {
                    return { ...item, checked: false }
                }
            })
            setProductList(temp)
        } else {
            setProductList(allProducts)
        }
    }, []);
    return (
        <>
            <Modal
                className='products-selection-modal'
                open={open}
                onCancel={() => {
                    closeModal();
                }}
                closable
                title={"Select Products"}
                footer={false}
            >
                <div className="products-listing">
                    {productList?.map((product, i) => {
                        return (
                            <div className="product-card-container">
                                <div className="product-card-item">
                                    <div className="image-container">
                                        <img className='product-image' src={product?.image} alt="Product Image" />
                                        <Checkbox defaultChecked={product?.checked} className='checkbox' onClick={(e) => handleSelectedProducts(e, i)} />
                                    </div>
                                    <div className="product-details-container">
                                        {product?.title}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="btn-container">
                    <Button className='add-btn' onClick={() => {
                        productsCrud(productList);
                        closeModal();
                    }}>Save Products</Button>
                </div>
            </Modal>
        </>
    )
}
